var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("van-icon", {
            staticClass: "header-return",
            attrs: { name: "arrow-left", size: "25", color: "#ffffff" },
            on: {
              click: function($event) {
                return _vm.onClickHeaderReturn()
              }
            }
          }),
          _vm._v("\n    Sign Up\n  ")
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "register-msg" }, [
            _vm._v("Complete your profiles")
          ]),
          _c("div", { staticClass: "register-title" }, [
            _vm._v("Your Email *")
          ]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.newAccount.email,
                expression: "newAccount.email",
                modifiers: { trim: true }
              }
            ],
            staticClass: "register-input",
            attrs: {
              type: "text",
              placeholder: "Fairy spirit",
              maxlength: "30"
            },
            domProps: { value: _vm.newAccount.email },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.newAccount, "email", $event.target.value.trim())
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _c("div", { staticClass: "register-title" }, [_vm._v("Password *")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.newAccount.password,
                expression: "newAccount.password",
                modifiers: { trim: true }
              }
            ],
            staticClass: "register-input",
            attrs: {
              type: "password",
              placeholder: "Enter login password",
              minlength: "6",
              maxlength: "20"
            },
            domProps: { value: _vm.newAccount.password },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.newAccount, "password", $event.target.value.trim())
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._m(0),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.newAccount.name,
                expression: "newAccount.name",
                modifiers: { trim: true }
              }
            ],
            staticClass: "register-input",
            attrs: {
              type: "text",
              placeholder: "Enter you name",
              maxlength: "30"
            },
            domProps: { value: _vm.newAccount.name },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.newAccount, "name", $event.target.value.trim())
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._m(1),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.newAccount.companyName,
                expression: "newAccount.companyName",
                modifiers: { trim: true }
              }
            ],
            staticClass: "register-input",
            attrs: {
              type: "text",
              placeholder: "Enter your company name",
              maxlength: "30"
            },
            domProps: { value: _vm.newAccount.companyName },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(
                  _vm.newAccount,
                  "companyName",
                  $event.target.value.trim()
                )
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._m(2),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.newAccount.brandName,
                expression: "newAccount.brandName",
                modifiers: { trim: true }
              }
            ],
            staticClass: "register-input",
            attrs: {
              type: "text",
              placeholder: "Enter the brand name",
              maxlength: "30"
            },
            domProps: { value: _vm.newAccount.brandName },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(
                  _vm.newAccount,
                  "brandName",
                  $event.target.value.trim()
                )
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._m(3),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.newAccount.phoneNumber,
                expression: "newAccount.phoneNumber",
                modifiers: { trim: true }
              }
            ],
            staticClass: "register-input",
            attrs: {
              type: "text",
              placeholder: "Your phone number",
              maxlength: "30"
            },
            domProps: { value: _vm.newAccount.phoneNumber },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(
                  _vm.newAccount,
                  "phoneNumber",
                  $event.target.value.trim()
                )
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _c(
            "van-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "register-confirm",
              attrs: { type: "default" },
              on: { click: _vm.onClickConfirm }
            },
            [_vm._v("\n      Confirm\n    ")]
          )
        ],
        1
      ),
      _c(
        "van-popup",
        {
          staticClass: "success-popup",
          style: { width: "88%" },
          attrs: { round: "", "close-on-click-overlay": false },
          model: {
            value: _vm.showSuccessPopup,
            callback: function($$v) {
              _vm.showSuccessPopup = $$v
            },
            expression: "showSuccessPopup"
          }
        },
        [
          _c(
            "div",
            { staticClass: "success-content" },
            [
              _c("div", { staticClass: "success-title" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/icons/icon_register_success.png")
                  }
                }),
                _vm._v("\n        Successful application\n      ")
              ]),
              _c("div", { staticClass: "success-msg" }, [
                _vm._v(
                  "\n        Your registration information has been submitted, please log in after\n        your account verification is passed\n      "
                )
              ]),
              _c(
                "van-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "success-button",
                  attrs: { type: "default" },
                  on: { click: _vm.onClickOk }
                },
                [_vm._v("\n        OK\n      ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "register-title" }, [
      _vm._v("Name "),
      _c("span", [_vm._v("(Optional)")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "register-title" }, [
      _vm._v("Company Name "),
      _c("span", [_vm._v("(Optional)")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "register-title" }, [
      _vm._v("Brand Name "),
      _c("span", [_vm._v("(Optional)")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "register-title" }, [
      _vm._v("Phone Number "),
      _c("span", [_vm._v("(Optional)")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }